export const AUTOMATION_MODAL = {
  ADD_ACTION: 'AUTOMATION_MODAL_ADD_ACTION',
  DELETE_ACTION: 'AUTOMATION_MODAL_DELETE_ACTION',
  DELETE_CONDITION: 'AUTOMATION_MODAL_DELETE_CONDITION',
  CONDITION_CONSTRAINT: 'AUTOMATION_MODAL_CONDITION_CONSTRAINT',
  SHOW_PUBLISH_MESSAGE: 'AUTOMATION_MODAL_SHOW_PUBLISH_MESSAGE',
  INACTIVE: 'AUTOMATION_MODAL_INACTIVE',
  SHARE_PROFILE_CONFIG: 'AUTOMATION_MODAL_SHARE_PROFILE_CONFIG',
};

export const AUTOMATION_EVENTS = {
  LOAD: 'AUTOMATION_EVENTS_LOAD',
  LOAD_SUCCESS: 'AUTOMATION_EVENTS_LOAD_SUCCESS',
  LOAD_FAILED: 'AUTOMATION_EVENTS_LOAD_FAILED',
  SET_SEARCH_TERM: 'AUTOMATION_EMAILS_SET_SEARCH_TERM',
};

export const CREATE_AUTOMATION = {
  ADD_NODE: 'CREATE_AUTOMATION_ADD_NODE',
  SAVE: 'CREATE_AUTOMATION_SAVE',
  UPDATE: 'CREATE_AUTOMATION_UPDATE',
  RESUME: 'CREATE_AUTOMATION_RESUME',
  LOADING: 'CREATE_AUTOMATION_LOADING',
  FAIL: 'CREATE_AUTOMATION_FAIL',
  RESET_MESSAGE: 'CREATE_AUTOMATION_RESET_MESSAGE',
  UPDATE_TOASTER_MESSAGE: 'CREATE_AUTOMATION_UPDATE_TOASTER_MESSAGE',
};

export const AUTOMATION_EMAILS = {
  LOAD: 'AUTOMATION_EMAILS_LOAD',
  LOAD_SUCCESS: 'AUTOMATION_EMAILS_LOAD_SUCCESS',
  LOAD_FAILED: 'AUTOMATION_EMAILS_LOAD_FAILED',
  SET_FILTERS: 'AUTOMATION_EMAILS_SET_FILTERS',
  SET_SEARCH_TERM: 'AUTOMATION_EMAILS_SET_SEARCH_TERM',
  RESET: 'AUTOMATION_EMAILS_RESET',
  SET_SELECTED_EMAIL_ID: 'AUTOMATION_EMAILS_SET_SELECTED_EMAIL_ID',
  SET_SHOW_UPDATE: 'AUTOMATION_EMAILS_SET_SHOW_UPDATE',
  SET_FORM: 'AUTOMATION_EMAILS_SET_FORM',
  SET_UPDATE_SUCCESS: 'AUTOMATION_EMAILS_SET_UPDATE_SUCCESS',
  RESET_FORM_DATA: 'AUTOMATION_EMAILS_RESET_FORM_DATA',
  UPDATE_EMAIL_DATA: 'AUTOMATION_EMAILS_UPDATE',
  UPDATE_FORM: 'AUTOMATION_EMAILS_UPDATE_FORM',
  UPDATE_FORM_CURRENT_DATA: 'AUTOMATION_EMAILS_UPDATE_FORM_CURRENT_DATA',
  SELECTED_ON_TOP: 'AUTOMATION_EMAILS_SELECTED_ON_TOP',
};

export const AUTOMATION_DROP_ITEM = {
  SAVE: 'AUTOMATION_DROP_ITEM_SAVE',
  CLEAR: 'AUTOMATION_DROP_ITEM_SAVE_CLEAR',
};

export const AUTOMATION_NODE = {
  DELETE: 'AUTOMATION_NODE_DELETE',
  COPY: 'AUTOMATION_NODE_COPY',
  CLEAR_COPY: 'AUTOMATION_NODE_CLEAR_COPY',
  MOVE: 'AUTOMATION_NODE_MOVE',
  EDIT: 'AUTOMATION_NODE_EDIT',
  ERROR: 'AUTOMATION_NODE_ERROR',
};

export const AUTOMATION_NAME_UPDATE = {
  LOAD: 'AUTOMATION_NAME_UPDATE_LOAD',
  SUCCESS: 'AUTOMATION_NAME_SUCCESS',
  FAIL: 'AUTOMATION_NAME_FAIL',
};

export const AUTOMATION_WORKFLOW = {
  RESET: 'AUTOMATION_WORKFLOW_RESET',
  LOAD: 'AUTOMATION_WORKFLOW_LOAD',
  EDITING_SHARE_PROFILE: 'EDITING_SHARE_PROFILE',
  LOAD_SUCCESS: 'AUTOMATION_WORKFLOW_LOAD_SUCCESS',
  LOAD_FAILED: 'AUTOMATION_WORKFLOW_LOAD_FAILED',
  ADD_EMAIL: 'AUTOMATION_WORKFLOW_ADD_EMAIL',
  REMOVE_EMAIL: 'AUTOMATION_WORKFLOW_REMOVE_EMAIL',
  RESET_EMAILS: 'AUTOMATION_WORKFLOW_RESET_EMAILS',
  SHARE_PROFILE_CONFIG_UPDATE: 'AUTOMATION_WORKFLOW_SHARE_PROFILE_CONFIG_UPDATE',
  SHARE_PROFILE_CONFIG_DATA: 'AUTOMATION_WORKFLOW_SHARE_PROFILE_CONFIG_DATA',
  UPDATE_RECENTLY_PUBLISHED: 'AUTOMATION_WORKFLOW_UPDATE_RECENTLY_PUBLISHED',
  UPDATE_ERROR_NODES_LIST: 'AUTOMATION_WORKFLOW_UPDATE_ERROR_NODES_LIST',
  UPDATE_ERROR_PUBLISH_NODES_LIST: 'AUTOMATION_WORKFLOW_UPDATE_ERROR_PUBLISH_NODES_LIST',
  EMPTY_NEWLY_ADDED_NODES: 'AUTOMATION_WORKFLOW_EMPTY_NEWLY_ADDED_NODES',
  UPDATE_SAME_EMAIL_NODES_TITLE: 'AUTOMATION_WORKFLOW_UPDATE_SAME_EMAIL_NODES_TITLE',
  UPDATE_SAVE_BUTTON_STATE: 'AUTOMATION_WORKFLOW_UPDATE_SAVE_BUTTON_STATE',
  UPDATE_ALL_EMAILS_DESIGN_READY: 'AUTOMATION_WORKFLOW_UPDATE_ALL_EMAILS_DESIGN_READY',
};

export const AUTOMATION_SHARED_PROFILE_STATIC_DATA = {
  LOAD: 'AUTOMATION_SHARED_PROFILE_STATIC_DATA_LOAD',
  SUCCESS: 'AUTOMATION_SHARED_PROFILE_STATIC_DATA_SUCCESS',
  FAIL: 'AUTOMATION_SHARED_PROFILE_STATIC_DATA_FAIL',
};

export const AUTOMATION_LISTS = {
  LOAD: 'AUTOMATION_LISTS_LOAD',
  LOAD_SUCCESS: 'AUTOMATION_LISTS_LOAD_SUCCESS',
  LOAD_FAILED: 'AUTOMATION_LISTS_LOAD_FAILED',
  SET_SEARCH_TERM: 'AUTOMATION_LISTS_SET_SEARCH_TERM',
  SET_SEARCH_DATA: 'AUTOMATION_LISTS_SET_SEARCH_DATA',
  RESET_SEARCH_DATA: 'AUTOMATION_LISTS_RESET_SEARCH_DATA',
  SET_SELECTED_LIST_IDS: 'AUTOMATION_LISTS_SET_SELECTED_LIST_IDS',
  SET_SELECTED_LISTS: 'AUTOMATION_LISTS_SET_SELECTED_LISTS',
  NEW_LIST_CREATED: 'AUTOMATION_LISTS_NEW_LIST_CREATED',
  NEW_LIST_DATA_RESET: 'AUTOMATION_LISTS_NEW_LIST_DATA_RESET',
  CREATED_SUCCESS_STATE: 'AUTOMATION_LISTS_CREATED_SUCCESS_STATE',
  CREATED_ERROR_STATE: 'AUTOMATION_LISTS_CREATED_ERROR_STATE',
  RESET: 'AUTOMATION_LISTS_RESET',
};

export const AUTOMATION_LISTS_TRIGGER = {
  LOAD: 'AUTOMATION_LISTS_TRIGGER_LOAD',
  LOAD_SUCCESS: 'AUTOMATION_LISTS_TRIGGER_LOAD_SUCCESS',
  LOAD_FAILED: 'AUTOMATION_LISTS_TRIGGER_LOAD_FAILED',
  SET_SEARCH_TERM: 'AUTOMATION_LISTS_TRIGGER_SET_SEARCH_TERM',
  SET_SEARCH_DATA: 'AUTOMATION_LISTS_TRIGGER_SET_SEARCH_DATA',
  RESET_SEARCH_DATA: 'AUTOMATION_LISTS_TRIGGER_RESET_SEARCH_DATA',
  RESET: 'AUTOMATION_LISTS_TRIGGER_RESET',
};

export const AUTOMATION_CONTROLS = {
  SAVE: 'AUTOMATION_CONTROLS_SAVE',
};

export const AUTOMATION_USER_WORKFLOWS = {
  LOAD: 'AUTOMATION_USER_WORKFLOWS_LOAD',
  LOAD_SUCCESS: 'AUTOMATION_USER_WORKFLOWS_LOAD_SUCCESS',
  LOAD_FAILED: 'AUTOMATION_USER_WORKFLOWS_LOAD_FAILED',
  ERROR_SEARCH_TERM: 'AUTOMATION_USER_WORKFLOWS_ERROR_SEARCH_TERM',
  ERROR_SEARCH_TERM_LOADING: 'AUTOMATION_USER_WORKFLOWS_ERROR_SEARCH_TERM_LOADING',
  SET_SEARCH_TERM: 'AUTOMATION_USER_WORKFLOWS_SET_SEARCH_TERM',
  SET_FILTER_TYPE: 'AUTOMATION_USER_WORKFLOWS_SET_FILTER_TYPE',
  RESET: 'AUTOMATION_USER_WORKFLOWS_RESET',
  UPDATE_USERS_WORKFLOW_STATUS: 'AUTOMATION_USERS_WORKFLOW_STATUS_UPDATE',
  UPDATE_USERS_WORKFLOW_NAME: 'AUTOMATION_USERS_WORKFLOW_NAME_UPDATE',
  INCREMENT_ACTIVE_COUNT: 'INCREMENT_ACTIVE_COUNT',
  DECREMENT_ACTIVE_COUNT: 'DECREMENT_ACTIVE_COUNT',
  INCREMENT_TOTAL_COUNT: 'INCREMENT_TOTAL_COUNT',
};

export const AUTOMATION_USER_WORKFLOWS_DELETE = {
  LOAD: 'AUTOMATION_USER_WORKFLOWS_DELETE_LOAD',
  LOAD_SUCCESS: 'AUTOMATION_USER_WORKFLOWS_DELETE_LOAD_SUCCESS',
  LOAD_FAILED: 'AUTOMATION_USER_WORKFLOWS_DELETE_LOAD_FAILED',
};

export const AUTOMATION_WORKFLOW_STATUS_UPDATE = {
  LOAD: 'AUTOMATION_WORKFLOW_STATUS_UPDATE_LOAD',
  LOAD_SUCCESS: 'AUTOMATION_WORKFLOW_STATUS_UPDATE_LOAD_SUCCESS',
  LOAD_FAILED: 'AUTOMATION_WORKFLOW_STATUS_UPDATE_LOAD_FAILED',
  ERROR_UPDATE: 'AUTOMATION_WORKFLOW_STATUS_UPDATE_ERROR_UPDATE',
};

export const AUTOMATION_WORKFLOW_IF_ELSE_MODAL = {
  SET_CONDITION_EMAIL: 'AUTOMATION_WORKFLOW_IF_ELSE_MODAL_SET_CONDITION_EMAIL',
};

export const AUTOMATION_WORKFLOW_CONDITION_EMAILS_LINKS = {
  LOAD: 'AUTOMATION_WORKFLOW_CONDITION_EMAILS_LINKS_LOADING',
  LOAD_SUCCESS: 'AUTOMATION_WORKFLOW_CONDITION_EMAILS_LINKS_LOAD_SUCCESS',
  LOAD_FAILED: 'AUTOMATION_WORKFLOW_CONDITION_EMAILS_LINKS_LOAD_FAILED',
  RESET: 'AUTOMATION_WORKFLOW_CONDITION_EMAILS_LINKS_RESET',
};

export const AUTOMATION_WORKFLOW_EMAIL_PREVIEW = {
  LOAD: 'AUTOMATION_WORKFLOW_EMAIL_PREVIEW_LOAD',
  LOAD_SUCCESS: 'AUTOMATION_WORKFLOW_EMAIL_PREVIEW_LOAD_SUCCESS',
  LOAD_FAILED: 'AUTOMATION_WORKFLOW_EMAIL_PREVIEW_LOAD_FAILED',
  RESET: 'AUTOMATION_WORKFLOW_EMAIL_PREVIEW_RESET',
  RESET_SELECTED_EMAIL_ID: 'AUTOMATION_WORKFLOW_EMAIL_PREVIEW_RESET_SELECTED_EMAIL_ID',
  LOAD_TEXT_PREVIEW_SUCCESS: 'AUTOMATION_WORKFLOW_EMAIL_PREVIEW_LOAD_TEXT_PREVIEW_SUCCESS',
};

export const AUTOMATION_WORKFLOW_TRIGGER_EMAIL = {
  LOAD: 'AUTOMATION_WORKFLOW_TRIGGER_EMAIL_LOAD',
  FAIL: 'AUTOMATION_WORKFLOW_TRIGGER_EMAIL_FAIL',
  UPDATE: 'AUTOMATION_WORKFLOW_TRIGGER_EMAIL_UPDATE',
};

export const AUTOMATION_WORKFLOW_TRIGGER_LIST = {
  UPDATE: 'AUTOMATION_WORKFLOW_TRIGGER_LIST_UPDATE',
};

export const AUTOMATION_WORKFLOW_CLONE = {
  LOAD: 'AUTOMATION_WORKFLOW_CLONE_LOAD',
  LOAD_SUCCESS: 'AUTOMATION_WORKFLOW_CLONE_LOAD_SUCCESS',
  LOAD_FAILED: 'AUTOMATION_WORKFLOW_CLONE_LOAD_FAILED',
  RESET: 'AUTOMATION_WORKFLOW_CLONE_RESET',
};

export const AUTOMATION_EMAILS_ANALYTICS_LIST = {
  LOAD: 'AUTOMATION_EMAILS_ANALYTICS_LIST_LOAD',
  SET_DATA: 'AUTOMATION_EMAILS_ANALYTICS_LIST_SET_DATA',
  RESET_DATA: 'AUTOMATION_EMAILS_ANALYTICS_LIST_RESET_DATA',
};

export const AUTOMATION_EMAILS_GRAPH_DATA = {
  LOAD: 'AUTOMATION_EMAILS_GRAPH_DATA_LOAD',
  SET_DATA: 'AUTOMATION_EMAILS_GRAPH_DATA_SET_DATA',
  RESET_DATA: 'AUTOMATION_EMAILS_GRAPH_DATA_RESET_DATA',
  SET_DATE: 'AUTOMATION_EMAILS_GRAPH_DATA_SET_DATE',
  RESET_DATE: 'AUTOMATION_EMAILS_GRAPH_DATA_RESET_DATE',
};
